import Commons from '../../../../Services/Common/Common';
const encryptWithDebug = (label, raw) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[SAT_BASIC_05][encrypt-before] ${label}:`, raw);
  }
  return Commons.EncryptAES(raw);
};
export const SAT_BASIC_05_Schema = {
  fields: {
    no: { initial: '', label: 'NO' },
    sheGubun: { initial: '', label: '교육 구분', required: 'Y' },
    sheNm: { initial: '', label: '교육명', required: 'Y' },
    sheTargetCount: { initial: '', label: '교육대상자', required: 'Y' },
    sheTime: { initial: '', label: '교육 시간(시간)', required: 'Y' },
    sheYn: { initial: 'OFF', label: '교육 실시 여부' },
  },

  mapper: {
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      StartYear: (_, context) =>
        Commons.EncryptAES(context.search?.year.toString()) || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
    },
    search2: {
      SheId: (_, context) =>
        Commons.EncryptAES((context.sheId ?? 0).toString()) || '',
    },
    search3: {
      UserId: (_, context) => context.userInfo.userid,
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo.authCd),
      CoCd: (_, context) => Commons.EncryptAES(context.userInfo.coCd),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText),
    },

    save1: {
      SheId: (row) => Commons.EncryptAES((row.sheId || 0).toString()) || '',
      SheGubun: (row) => Commons.EncryptAES(row.sheGubun) || '',
      SheNm: (row) => Commons.EncryptAES(row.sheNm || '') || '',
      SheTime: (row) => Commons.EncryptAES((row.sheTime || 0).toString()) || '',
      SheYn: (row) => Commons.EncryptAES(row.sheYn || 'OFF') || '',
      SheYear: (_, context) =>
        Commons.EncryptAES(context.search?.year.toString()) || '',
      ShePeriod: (row) => Commons.EncryptAES(row.shePeriod || '') || '',
      SheGraduate: (row) =>
        Commons.EncryptAES((row.sheGraduate || 0).toString()) || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
    },
    save2: {
      SheId: (row) => Commons.EncryptAES((row.sheId || 0).toString()) || '',
      Id: (row) => Commons.EncryptAES(row.targetId || ''),
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    delete1: {
      SheId: (row) => Commons.EncryptAES((row.sheId || 0).toString()) || '',
    },
    delete2: {
      SheId: (row) => Commons.EncryptAES((row.sheId || 0).toString()) || '',
      Id: (row) => encryptWithDebug('delete2.Id', row.targetId || ''),
    },
  },
};
